import _sfc_main from "./MemberInvite.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "member-invite-container" }, [_setup.showReject ? _c("span", { staticClass: "member-invite-reject" }, [_vm._v(_vm._s(_setup.t("Not joining for now")))]) : _vm._e(), _vm.userInfo.status === _setup.TUIInvitationStatus.kPending ? _c("span", { staticClass: "member-invite-calling" }, [_vm._v(" " + _vm._s(_setup.t("Calling...")) + " ")]) : _c(_setup.TuiButton, { staticClass: "button", attrs: { "size": "default" }, on: { "click": _setup.handleInvite } }, [_vm._v(" " + _vm._s(_setup.t("Call")) + " ")])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1d45fc0f"
);
const MemberInvite = __component__.exports;
export {
  MemberInvite as default
};
